import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-form-ok-cancel',
  templateUrl: './form-ok-cancel.component.html',
  styleUrls: ['./form-ok-cancel.component.scss']
})
export class FormOkCancelComponent implements OnInit {

  constructor() { }

  @Input() vm: IFormOkCancelViewModel;

  @Output() cancelClicked = new EventEmitter();
  @Output() okClicked = new EventEmitter();

  /**
   * 
   */
  ngOnInit() {
  }

  ok() {
    this.okClicked.emit();
  }

  cancel() {
    this.cancelClicked.emit();
  }

  /**
   * 
   * @returns 
   */
  public static okCancelVm(options: IFormOkCancelOptions = {}): IFormOkCancelViewModel {
    const ret: IFormOkCancelViewModel = {
      okText: options.okText || 'ok',
      cancelText: options.cancelText ?? 'cancel',
      isValid: false
    };
    return ret;
  }

  /**
   * generic recipe for running the "ok" logic asynchronously
   * @param vm 
   * @param workingText 
   * @param workFunc 
   * @param completeFunc 
   */
  public static async processOkAsync(vm: IFormOkCancelViewModel, workingText: string, workFunc: () => Observable<any>): Promise<boolean> {

    try {
      vm.workingText = workingText ?? 'Saving...';
      vm.errorText = undefined;

      const result = await of({}).pipe(
        delay(100),
        switchMap(() => workFunc())
      ).toPromise()
    

      if (result?.errorText)
        vm.errorText = result.errorText;

    } catch (err) {
      vm.errorText = err;
    } finally {
      vm.workingText = undefined;
    }

    return vm.errorText ? false : true;
  }

}

/**
 * 
 */
export class IFormOkCancelViewModel {
  workingText?: string;
  errorText?: string;

  isValid: boolean;

  okText?: string;
  cancelText?: string;
}

/**
 * 
 */
export class IFormOkCancelOptions {
  okText?: string;
  cancelText?: string
}